// ACTIONS
function nextFundCreationStep({ commit }) {
  commit('nextStep')
}
function prevFundCreationStep({ commit }) {
  commit('previousStep')
}
function resetCreateFundStoreAction({ commit }) {
  commit('resetCreateFundStore')
}

function setFundDtoPropertyAction({ commit }, attributeObj) {
  commit('setFundDtoProperty', attributeObj)
}
function nullifyFundDtoPropertyAction({ commit }, attributeKey) {
  commit('nullifyFundDtoProperty', attributeKey)
}

function deleteFundDtoPropertyAction({ commit }, attributeKey) {
  commit('deleteFundDtoProperty', attributeKey)
}

// INITIAL STATE DECLARATION

const initialState = () => ({
  currentStep: 1,
  fundDto: {}
})

// MUTATIONS
function nextStep(state) {
  if (state.currentStep === 3) {
    return
  }
  state.currentStep++
}
function previousStep(state) {
  if (state.currentStep === 1) {
    return
  }
  state.currentStep--
}
function resetCreateFundStore(state) {
  Object.assign(state, initialState())
}

function setFundDtoProperty(state, attributeObj) {
  state.fundDto = { ...state.fundDto, ...attributeObj }
}
function nullifyFundDtoProperty(state, attributeKey) {
  if (state.fundDto[attributeKey]) {
    state.fundDto[attributeKey] = null
  }
}

function deleteFundDtoProperty(state, attributeKey) {
  if (state.fundDto[attributeKey]) {
    delete state.fundDto[attributeKey]
  }
}

const fundMapStore = {
  state: initialState(),
  actions: {
    nextFundCreationStep,
    prevFundCreationStep,
    resetCreateFundStoreAction,
    setFundDtoPropertyAction,
    nullifyFundDtoPropertyAction,
    deleteFundDtoPropertyAction
  },
  getters: {
    fundCreationStep: state => state.currentStep,
    newFundDto: state => state.fundDto
  },
  mutations: {
    nextStep,
    previousStep,
    resetCreateFundStore,
    setFundDtoProperty,
    nullifyFundDtoProperty,
    deleteFundDtoProperty
  }
}

export default fundMapStore
